import { render } from "./cotacaofretebaseelk-imp-padrao.vue?vue&type=template&id=7f18e402&scoped=true"
import script from "./cotacaofretebaseelk-imp-padrao.vue?vue&type=script&lang=js"
export * from "./cotacaofretebaseelk-imp-padrao.vue?vue&type=script&lang=js"

import "./cotacaofretebaseelk-imp-padrao.vue?vue&type=style&index=0&id=7f18e402&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f18e402"]])

export default __exports__